export type LogbookIconsId =
  | "wifi"
  | "weather-9"
  | "weather-8"
  | "weather-7"
  | "weather-6"
  | "weather-5"
  | "weather-4"
  | "weather-3"
  | "weather-2"
  | "weather-16"
  | "weather-15"
  | "weather-14"
  | "weather-13"
  | "weather-12"
  | "weather-11"
  | "weather-10"
  | "weather-1"
  | "watch"
  | "user"
  | "usb"
  | "trip"
  | "trash"
  | "track"
  | "toggle"
  | "toggle-on"
  | "status-waiting"
  | "status-port"
  | "status-onboard"
  | "status-offboard"
  | "status-lock"
  | "status-inmotion"
  | "status-drifting"
  | "status-buoy"
  | "status-bunkering"
  | "status-bridge"
  | "status-anchor"
  | "stats"
  | "sounding"
  | "settings"
  | "search"
  | "sails-up"
  | "sails-down"
  | "sails-change"
  | "sailing-vessel"
  | "sailing-vessel-large"
  | "refresh"
  | "print"
  | "plus"
  | "on2"
  | "on1"
  | "on"
  | "off2"
  | "off1"
  | "off"
  | "note"
  | "note-weather-report"
  | "note-weather-forecast"
  | "note-technical"
  | "note-journal"
  | "note-cruise-plan"
  | "no-cloud"
  | "navigation"
  | "navigation-level-3"
  | "navigation-level-2"
  | "navigation-level-1"
  | "navigation-level-0"
  | "motor-vessel"
  | "moon-waxing"
  | "moon-waning"
  | "moon-new"
  | "moon-full"
  | "lights"
  | "lighting-tricolor"
  | "lighting-sailing-running"
  | "lighting-none"
  | "lighting-motoring-running"
  | "lighting-motoring-cone"
  | "lighting-anchor-light"
  | "lighting-anchor-ball"
  | "graph"
  | "gps"
  | "gps-unfilled"
  | "gen-water"
  | "gen-power"
  | "gen-heater"
  | "gen-ac"
  | "eye-on"
  | "eye-off"
  | "environment"
  | "enter"
  | "edit"
  | "day"
  | "cruise"
  | "copy"
  | "compass"
  | "compass-filled"
  | "companion"
  | "cloud"
  | "close"
  | "circle-large"
  | "circle-half-large"
  | "circle-filled-large"
  | "checklist"
  | "box"
  | "box-filled"
  | "bluetooth"
  | "arrows-up"
  | "arrows-right"
  | "arrows-left"
  | "arrows-down"
  | "arrow-up"
  | "arrow-right"
  | "arrow-left"
  | "arrow-down"
  | "alert"
  | "advice-wind"
  | "advice-test"
  | "advice-stop"
  | "advice-pressure"
  | "advice-message"
  | "advice-manual-ship-status"
  | "advice-man-overboard"
  | "advice-lost-position"
  | "advice-lights"
  | "advice-depth"
  | "advice-anchor"
  | "advice-anchor-drift"
  | "account";

export type LogbookIconsKey =
  | "Wifi"
  | "Weather9"
  | "Weather8"
  | "Weather7"
  | "Weather6"
  | "Weather5"
  | "Weather4"
  | "Weather3"
  | "Weather2"
  | "Weather16"
  | "Weather15"
  | "Weather14"
  | "Weather13"
  | "Weather12"
  | "Weather11"
  | "Weather10"
  | "Weather1"
  | "Watch"
  | "User"
  | "Usb"
  | "Trip"
  | "Trash"
  | "Track"
  | "Toggle"
  | "ToggleOn"
  | "StatusWaiting"
  | "StatusPort"
  | "StatusOnboard"
  | "StatusOffboard"
  | "StatusLock"
  | "StatusInmotion"
  | "StatusDrifting"
  | "StatusBuoy"
  | "StatusBunkering"
  | "StatusBridge"
  | "StatusAnchor"
  | "Stats"
  | "Sounding"
  | "Settings"
  | "Search"
  | "SailsUp"
  | "SailsDown"
  | "SailsChange"
  | "SailingVessel"
  | "SailingVesselLarge"
  | "Refresh"
  | "Print"
  | "Plus"
  | "On2"
  | "On1"
  | "On"
  | "Off2"
  | "Off1"
  | "Off"
  | "Note"
  | "NoteWeatherReport"
  | "NoteWeatherForecast"
  | "NoteTechnical"
  | "NoteJournal"
  | "NoteCruisePlan"
  | "NoCloud"
  | "Navigation"
  | "NavigationLevel3"
  | "NavigationLevel2"
  | "NavigationLevel1"
  | "NavigationLevel0"
  | "MotorVessel"
  | "MoonWaxing"
  | "MoonWaning"
  | "MoonNew"
  | "MoonFull"
  | "Lights"
  | "LightingTricolor"
  | "LightingSailingRunning"
  | "LightingNone"
  | "LightingMotoringRunning"
  | "LightingMotoringCone"
  | "LightingAnchorLight"
  | "LightingAnchorBall"
  | "Graph"
  | "Gps"
  | "GpsUnfilled"
  | "GenWater"
  | "GenPower"
  | "GenHeater"
  | "GenAc"
  | "EyeOn"
  | "EyeOff"
  | "Environment"
  | "Enter"
  | "Edit"
  | "Day"
  | "Cruise"
  | "Copy"
  | "Compass"
  | "CompassFilled"
  | "Companion"
  | "Cloud"
  | "Close"
  | "CircleLarge"
  | "CircleHalfLarge"
  | "CircleFilledLarge"
  | "Checklist"
  | "Box"
  | "BoxFilled"
  | "Bluetooth"
  | "ArrowsUp"
  | "ArrowsRight"
  | "ArrowsLeft"
  | "ArrowsDown"
  | "ArrowUp"
  | "ArrowRight"
  | "ArrowLeft"
  | "ArrowDown"
  | "Alert"
  | "AdviceWind"
  | "AdviceTest"
  | "AdviceStop"
  | "AdvicePressure"
  | "AdviceMessage"
  | "AdviceManualShipStatus"
  | "AdviceManOverboard"
  | "AdviceLostPosition"
  | "AdviceLights"
  | "AdviceDepth"
  | "AdviceAnchor"
  | "AdviceAnchorDrift"
  | "Account";

export enum LogbookIcons {
  Wifi = "wifi",
  Weather9 = "weather-9",
  Weather8 = "weather-8",
  Weather7 = "weather-7",
  Weather6 = "weather-6",
  Weather5 = "weather-5",
  Weather4 = "weather-4",
  Weather3 = "weather-3",
  Weather2 = "weather-2",
  Weather16 = "weather-16",
  Weather15 = "weather-15",
  Weather14 = "weather-14",
  Weather13 = "weather-13",
  Weather12 = "weather-12",
  Weather11 = "weather-11",
  Weather10 = "weather-10",
  Weather1 = "weather-1",
  Watch = "watch",
  User = "user",
  Usb = "usb",
  Trip = "trip",
  Trash = "trash",
  Track = "track",
  Toggle = "toggle",
  ToggleOn = "toggle-on",
  StatusWaiting = "status-waiting",
  StatusPort = "status-port",
  StatusOnboard = "status-onboard",
  StatusOffboard = "status-offboard",
  StatusLock = "status-lock",
  StatusInmotion = "status-inmotion",
  StatusDrifting = "status-drifting",
  StatusBuoy = "status-buoy",
  StatusBunkering = "status-bunkering",
  StatusBridge = "status-bridge",
  StatusAnchor = "status-anchor",
  Stats = "stats",
  Sounding = "sounding",
  Settings = "settings",
  Search = "search",
  SailsUp = "sails-up",
  SailsDown = "sails-down",
  SailsChange = "sails-change",
  SailingVessel = "sailing-vessel",
  SailingVesselLarge = "sailing-vessel-large",
  Refresh = "refresh",
  Print = "print",
  Plus = "plus",
  On2 = "on2",
  On1 = "on1",
  On = "on",
  Off2 = "off2",
  Off1 = "off1",
  Off = "off",
  Note = "note",
  NoteWeatherReport = "note-weather-report",
  NoteWeatherForecast = "note-weather-forecast",
  NoteTechnical = "note-technical",
  NoteJournal = "note-journal",
  NoteCruisePlan = "note-cruise-plan",
  NoCloud = "no-cloud",
  Navigation = "navigation",
  NavigationLevel3 = "navigation-level-3",
  NavigationLevel2 = "navigation-level-2",
  NavigationLevel1 = "navigation-level-1",
  NavigationLevel0 = "navigation-level-0",
  MotorVessel = "motor-vessel",
  MoonWaxing = "moon-waxing",
  MoonWaning = "moon-waning",
  MoonNew = "moon-new",
  MoonFull = "moon-full",
  Lights = "lights",
  LightingTricolor = "lighting-tricolor",
  LightingSailingRunning = "lighting-sailing-running",
  LightingNone = "lighting-none",
  LightingMotoringRunning = "lighting-motoring-running",
  LightingMotoringCone = "lighting-motoring-cone",
  LightingAnchorLight = "lighting-anchor-light",
  LightingAnchorBall = "lighting-anchor-ball",
  Graph = "graph",
  Gps = "gps",
  GpsUnfilled = "gps-unfilled",
  GenWater = "gen-water",
  GenPower = "gen-power",
  GenHeater = "gen-heater",
  GenAc = "gen-ac",
  EyeOn = "eye-on",
  EyeOff = "eye-off",
  Environment = "environment",
  Enter = "enter",
  Edit = "edit",
  Day = "day",
  Cruise = "cruise",
  Copy = "copy",
  Compass = "compass",
  CompassFilled = "compass-filled",
  Companion = "companion",
  Cloud = "cloud",
  Close = "close",
  CircleLarge = "circle-large",
  CircleHalfLarge = "circle-half-large",
  CircleFilledLarge = "circle-filled-large",
  Checklist = "checklist",
  Box = "box",
  BoxFilled = "box-filled",
  Bluetooth = "bluetooth",
  ArrowsUp = "arrows-up",
  ArrowsRight = "arrows-right",
  ArrowsLeft = "arrows-left",
  ArrowsDown = "arrows-down",
  ArrowUp = "arrow-up",
  ArrowRight = "arrow-right",
  ArrowLeft = "arrow-left",
  ArrowDown = "arrow-down",
  Alert = "alert",
  AdviceWind = "advice-wind",
  AdviceTest = "advice-test",
  AdviceStop = "advice-stop",
  AdvicePressure = "advice-pressure",
  AdviceMessage = "advice-message",
  AdviceManualShipStatus = "advice-manual-ship-status",
  AdviceManOverboard = "advice-man-overboard",
  AdviceLostPosition = "advice-lost-position",
  AdviceLights = "advice-lights",
  AdviceDepth = "advice-depth",
  AdviceAnchor = "advice-anchor",
  AdviceAnchorDrift = "advice-anchor-drift",
  Account = "account",
}

export const LOGBOOK_ICONS_CODEPOINTS: { [key in LogbookIcons]: string } = {
  [LogbookIcons.Wifi]: "61697",
  [LogbookIcons.Weather9]: "61698",
  [LogbookIcons.Weather8]: "61699",
  [LogbookIcons.Weather7]: "61700",
  [LogbookIcons.Weather6]: "61701",
  [LogbookIcons.Weather5]: "61702",
  [LogbookIcons.Weather4]: "61703",
  [LogbookIcons.Weather3]: "61704",
  [LogbookIcons.Weather2]: "61705",
  [LogbookIcons.Weather16]: "61706",
  [LogbookIcons.Weather15]: "61707",
  [LogbookIcons.Weather14]: "61708",
  [LogbookIcons.Weather13]: "61709",
  [LogbookIcons.Weather12]: "61710",
  [LogbookIcons.Weather11]: "61711",
  [LogbookIcons.Weather10]: "61712",
  [LogbookIcons.Weather1]: "61713",
  [LogbookIcons.Watch]: "61714",
  [LogbookIcons.User]: "61715",
  [LogbookIcons.Usb]: "61716",
  [LogbookIcons.Trip]: "61717",
  [LogbookIcons.Trash]: "61718",
  [LogbookIcons.Track]: "61719",
  [LogbookIcons.Toggle]: "61720",
  [LogbookIcons.ToggleOn]: "61721",
  [LogbookIcons.StatusWaiting]: "61722",
  [LogbookIcons.StatusPort]: "61723",
  [LogbookIcons.StatusOnboard]: "61724",
  [LogbookIcons.StatusOffboard]: "61725",
  [LogbookIcons.StatusLock]: "61726",
  [LogbookIcons.StatusInmotion]: "61727",
  [LogbookIcons.StatusDrifting]: "61728",
  [LogbookIcons.StatusBuoy]: "61729",
  [LogbookIcons.StatusBunkering]: "61730",
  [LogbookIcons.StatusBridge]: "61731",
  [LogbookIcons.StatusAnchor]: "61732",
  [LogbookIcons.Stats]: "61733",
  [LogbookIcons.Sounding]: "61734",
  [LogbookIcons.Settings]: "61735",
  [LogbookIcons.Search]: "61736",
  [LogbookIcons.SailsUp]: "61737",
  [LogbookIcons.SailsDown]: "61738",
  [LogbookIcons.SailsChange]: "61739",
  [LogbookIcons.SailingVessel]: "61740",
  [LogbookIcons.SailingVesselLarge]: "61741",
  [LogbookIcons.Refresh]: "61742",
  [LogbookIcons.Print]: "61743",
  [LogbookIcons.Plus]: "61744",
  [LogbookIcons.On2]: "61745",
  [LogbookIcons.On1]: "61746",
  [LogbookIcons.On]: "61747",
  [LogbookIcons.Off2]: "61748",
  [LogbookIcons.Off1]: "61749",
  [LogbookIcons.Off]: "61750",
  [LogbookIcons.Note]: "61751",
  [LogbookIcons.NoteWeatherReport]: "61752",
  [LogbookIcons.NoteWeatherForecast]: "61753",
  [LogbookIcons.NoteTechnical]: "61754",
  [LogbookIcons.NoteJournal]: "61755",
  [LogbookIcons.NoteCruisePlan]: "61756",
  [LogbookIcons.NoCloud]: "61757",
  [LogbookIcons.Navigation]: "61758",
  [LogbookIcons.NavigationLevel3]: "61759",
  [LogbookIcons.NavigationLevel2]: "61760",
  [LogbookIcons.NavigationLevel1]: "61761",
  [LogbookIcons.NavigationLevel0]: "61762",
  [LogbookIcons.MotorVessel]: "61763",
  [LogbookIcons.MoonWaxing]: "61764",
  [LogbookIcons.MoonWaning]: "61765",
  [LogbookIcons.MoonNew]: "61766",
  [LogbookIcons.MoonFull]: "61767",
  [LogbookIcons.Lights]: "61768",
  [LogbookIcons.LightingTricolor]: "61769",
  [LogbookIcons.LightingSailingRunning]: "61770",
  [LogbookIcons.LightingNone]: "61771",
  [LogbookIcons.LightingMotoringRunning]: "61772",
  [LogbookIcons.LightingMotoringCone]: "61773",
  [LogbookIcons.LightingAnchorLight]: "61774",
  [LogbookIcons.LightingAnchorBall]: "61775",
  [LogbookIcons.Graph]: "61776",
  [LogbookIcons.Gps]: "61777",
  [LogbookIcons.GpsUnfilled]: "61778",
  [LogbookIcons.GenWater]: "61779",
  [LogbookIcons.GenPower]: "61780",
  [LogbookIcons.GenHeater]: "61781",
  [LogbookIcons.GenAc]: "61782",
  [LogbookIcons.EyeOn]: "61783",
  [LogbookIcons.EyeOff]: "61784",
  [LogbookIcons.Environment]: "61785",
  [LogbookIcons.Enter]: "61786",
  [LogbookIcons.Edit]: "61787",
  [LogbookIcons.Day]: "61788",
  [LogbookIcons.Cruise]: "61789",
  [LogbookIcons.Copy]: "61790",
  [LogbookIcons.Compass]: "61791",
  [LogbookIcons.CompassFilled]: "61792",
  [LogbookIcons.Companion]: "61793",
  [LogbookIcons.Cloud]: "61794",
  [LogbookIcons.Close]: "61795",
  [LogbookIcons.CircleLarge]: "61796",
  [LogbookIcons.CircleHalfLarge]: "61797",
  [LogbookIcons.CircleFilledLarge]: "61798",
  [LogbookIcons.Checklist]: "61799",
  [LogbookIcons.Box]: "61800",
  [LogbookIcons.BoxFilled]: "61801",
  [LogbookIcons.Bluetooth]: "61802",
  [LogbookIcons.ArrowsUp]: "61803",
  [LogbookIcons.ArrowsRight]: "61804",
  [LogbookIcons.ArrowsLeft]: "61805",
  [LogbookIcons.ArrowsDown]: "61806",
  [LogbookIcons.ArrowUp]: "61807",
  [LogbookIcons.ArrowRight]: "61808",
  [LogbookIcons.ArrowLeft]: "61809",
  [LogbookIcons.ArrowDown]: "61810",
  [LogbookIcons.Alert]: "61811",
  [LogbookIcons.AdviceWind]: "61812",
  [LogbookIcons.AdviceTest]: "61813",
  [LogbookIcons.AdviceStop]: "61814",
  [LogbookIcons.AdvicePressure]: "61815",
  [LogbookIcons.AdviceMessage]: "61816",
  [LogbookIcons.AdviceManualShipStatus]: "61817",
  [LogbookIcons.AdviceManOverboard]: "61818",
  [LogbookIcons.AdviceLostPosition]: "61819",
  [LogbookIcons.AdviceLights]: "61820",
  [LogbookIcons.AdviceDepth]: "61821",
  [LogbookIcons.AdviceAnchor]: "61822",
  [LogbookIcons.AdviceAnchorDrift]: "61823",
  [LogbookIcons.Account]: "61824",
};
